import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { GetPhotoContentsListOutputRequestModel } from '../vo/get-photo-contents-list-output-request-model';

/**
 * 撮影リストエクセル出力項目取得
 */
@Injectable()
export class GetPhotoContentsListOutputService extends PlessJsonResponderSub<any> {

  private list: GetPhotoContentsListOutputRequestModel[];

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPhotoContentsListOutputService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: this.list.length === 0 ?
        {} : {
          ImageFileList: {
            combination: this.list.map(_ => {
              return {
                parameter: {
                  StartOrderCode: _.startOrderCode,
                  StatusName: _.statusName,
                  ClassCode: _.classCode,
                  ClassName: _.className,
                  PCode: _.pcode,
                  GuideGoodsName: _.guideGoodsName,
                  GuideStandardName: _.guideStandardName,
                  ImageFileName: _.imageFileName,
                  C2pfTarget: _.c2pfTarget,
                  ImageKind: _.imageKind,
                  ImageUseMethod: _.imageUseMethod,
                  PhotographingNo: _.photographingNo,
                  DelivCatalogMonth: _.delivCatalogMonth,
                  DelivCatalogTime: _.delivCatalogTime,
                  Packaging: _.packaging,
                  Plating: _.plating,
                  CookNecessary: _.cookNecessary,
                  CookUnnecessary: _.cookUnnecessary,
                  Explain: _.explain,
                  Other: _.other,
                  BackSide: _.backSide,
                  TempRange: _.tempRange,
                  MultipleCode: _.multipleCode,
                  PastImageInfo: _.pastImageInfo,
                  ImageCaution: _.imageCaution,
                  PhotoContentsName: _.photoContentsName,
                  ReferenceImageNum: _.referenceImageNum,
                  BillingName: _.billingName,
                  C2pfStatus: _.c2pfStatus,
                  DelayFlag: _.delayFlag,
                  SupplierAnnouncement: _.supplierAnnouncement,
                  SupplierInfo: _.supplierInfo,
                  StatusRemandReason: _.statusRemandReason,
                  Remarks: _.remarks,
                  PhotoSchedule: _.photoSchedule,
                  PhotographingChangeSchedule: _.photographingChangeSchedule,
                  CarriedForward: _.carriedForward,
                  ImageInstructDate: _.imageInstructDate,
                  ImageInstructUser: _.imageInstructUser,
                  BuyerName: _.buyerName,
                  C2pfUpdateDate: _.c2pfUpdateDate,
                  PeaceUpdateDate: _.peaceUpdateDate,
                  PrintDate: _.printDate,
                  PhotoStudio: _.photoStudio,
                  JanCode: _.janCode,
                  ImageGroupNo: _.imageGroupNo,
                  SmallClass: _.smallClass,
                  BuyerCode: _.buyerCode,
                  BillingCode: _.billingCode,
                  SampleOrderingCode: _.sampleOrderingCode,
                  SampleOrderingName: _.sampleOrderingName,
                  SupplierSalesStaffName: _.supplierSalesStaffName,
                  EbaseSpecCode: _.ebaseSpecCode
                }
              }
            })
          }
        }
    });
  }

  /**
   * API呼び出し
   *
   * @param {GetPhotoContentsListOutputRequestModel[]} [list]
   * @param {Function} [successFunc=null]
   * @memberof GetPhotoContentsListOutputService
   */
  execute(list: GetPhotoContentsListOutputRequestModel[], successFunc: Function): void {
    this.successFunc = successFunc;
    this.list = list;
    this.send('KYMW17GetPhotoContentsListOutput', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPhotoContentsListOutputService
   */
  success(data: any): void {
    if (this.successFunc !== null && data !== null) {
      this.successFunc(data.FileUrl);
    }
  }
}
